import React from 'react';
import { CssBaseline, Container } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import PaymentForm from './components/PaymentForm/PaymentForm';
import ThankYouPage from './components/ThankYouPage';
import AdminPaymentTable from './components/AdminPaymentTable/AdminPaymentTable';

function App() {
  return (
    <Router>
      <div className="App">
        <CssBaseline />
        <Container maxWidth={false}>

          <Header />
          <Routes>
            <Route path="/" element={<PaymentForm />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/admin/dashboard" element={<AdminPaymentTable />} />
          </Routes>
          <Footer />
        </Container>
      </div>
    </Router>
  );
}

export default App;